import React, { useEffect } from 'react';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMedal } from '@fortawesome/free-solid-svg-icons';
import { Award } from '../../global';
import { useNavigate } from 'react-router-dom';
import styles from './AwardRow.module.scss';
import DesignDefaultImg from '../../assets/Design.png';
import NamingDefaultImg from '../../assets/Naming.png';
import UserDefaultImg from '../../assets/Profile.png';
import { designUrlForContestName, userUrlForUser, briefUrlForContest } from '../../helpers/navigationUtils';
import { awardTitleString } from '../../helpers/utils';
import { useAuth } from '../../context/AuthContext';

interface IAwardRow {
  award: Award;
  show: 'contest' | 'designer';
}

export const AwardRow: React.FC<IAwardRow> = ({ award, show }) => {
  const redirect = useNavigate();
  const { isGod } = useAuth();
  useEffect(() => {
    console.log(award);
  }, [award]);

  const goToUserDetail = async () => {
    if (award.designerNameForURL) {
      redirect(userUrlForUser(award.designerNameForURL));
    }
  };
  const goToContestDetail = async () => {
    if (award.contestNameForURL) {
      redirect(briefUrlForContest(award.contestNameForURL));
    }
  };

  const goToDesignDetail = async () => {
    if (isGod() || (!award.isPrivate && award.designName)) {
      redirect(designUrlForContestName(award.contestNameForURL, award.designNameForURL));
    }
  };

  const designName = () => {
    if (award.designName) {
      return award.designName;
    } else {
      if (award.isPrivate) {
        return 'private gallery';
      } else {
        return 'coming soon';
      }
    }
  };

  const name = designName();
  return (
    <div className="row mb-4 px-4">
      <div className="col-12 px-4 bg-light radius-m  ">
        <div className="row mb-2">
          <div className="col-md-4 text-center mt-4  ">
            <div className={`d-flex flex-column justify-content-center align-items-center    `}>
              <div className="d-flex flex-column align-items-center justify-content-center  " style={{ height: '140px', width: '140px' }}>
                <FontAwesomeIcon style={{ fontSize: '7.5rem' }} icon={faMedal as IconProp} color="#55b9b9" className="text" />
                <div className={`d-flex flex-column justify-content-center ${award.name ? '' : 'mt-4 mb-3'} fw-bold `}>
                  <span
                    className={`text-xxl fw-bold ${award.name ? '' : 'mt-2'}`}
                    style={award.name ? { color: '#55b9b9', fontSize: '1.8rem' } : { color: '#55b9b9', fontSize: '2.2rem' }}
                  >
                    {award.price ? `€ ${award.price}` : '-'}
                  </span>
                  <span className={`text-s mt-2`}>{award.name}</span>
                </div>
              </div>
            </div>
            <div className="d-flex flex-row justify-content-center mt-3  ">
              <span className="fw-bold  ">{awardTitleString(award.title, award.pos)}</span>
            </div>
          </div>

          <div className="col-md-4 text-center mt-4  ">
            <div className="d-flex align-items-center justify-content-center   ">
              <img
                className={`img-fluid rounded ${!award.isPrivate && award.designImage && styles.cursorPointer}`}
                style={{ width: '140px', height: '140px' }}
                src={award.isNaming ? NamingDefaultImg : award.designImage || DesignDefaultImg}
                alt=""
                onClick={() => goToDesignDetail()}
              />
            </div>
            <div className="d-flex flex-row justify-content-center mt-3 ">
              <span className={`fw-bold ${!award.isPrivate && award.designName ? 'color-blue ' + styles.cursorPointer : ''}`} onClick={() => goToDesignDetail()}>
                {name}
              </span>
            </div>
          </div>

          <div className="col-md-4 text-center mt-4 ">
            <div className="d-flex  justify-content-center ">
              {show === 'designer' ? (
                <div
                  className={` ${styles.noProfileImg}  d-flex align-items-center justify-content-center ${award.designerUsername && styles.cursorPointer}`}
                  onClick={() => goToUserDetail()}
                >
                  <img src={award.designerLogo || UserDefaultImg} alt="defaultImg" className={`img-fluid`} style={{ width: '140px', height: '140px', borderRadius: '50%' }} />
                </div>
              ) : (
                <img className="img-fluid " style={{ width: '140px', height: '140px' }} src={award.contestImage} alt="Placeholder" onClick={() => goToContestDetail()} />
              )}
            </div>
            <div className="d-flex flex-row justify-content-center mt-3">
              {show === 'designer' ? (
                <span className={`fw-bold ${award.designerUsername ? 'color-blue ' + styles.cursorPointer : ''}`} onClick={() => goToUserDetail()}>
                  {award.designerUsername || 'coming soon'}
                </span>
              ) : (
                <span className="fw-bold color-blue" style={{ cursor: 'pointer' }} onClick={() => goToContestDetail()}>
                  {award.contestName}
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
